import { render } from "./TriagePatientQueueTab.vue?vue&type=template&id=0e9f0cb6"
import script from "./TriagePatientQueueTab.vue?vue&type=script&lang=js"
export * from "./TriagePatientQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__